import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination,Navigation } from 'swiper/modules';
import mfbg from "../images/logo.png"
import etabg from "../images/LoginImg.png"
import { useEffect } from 'react';


import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { useState } from 'react';

const Project = () => {

  const [spaceBetween, setSpaceBetween] = useState(-1200); // 기본값 설정

  useEffect(() => {
    // 화면 크기 변화를 감지하여 spaceBetween 값을 조정
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSpaceBetween(-300); // 작은 화면
      } else if (window.innerWidth <= 1024) {
        setSpaceBetween(-500); // 중간 화면
      } else if (window.innerWidth <= 1200) {
        setSpaceBetween(-700); // 중간 화면
      } else if (window.innerWidth <= 1400) {
        setSpaceBetween(-900); // 중간 화면
      } else if (window.innerWidth <= 1600) {
        setSpaceBetween(-1100); // 중간 화면
      } else {
        setSpaceBetween(-1200)
      }
    };

    // 컴포넌트가 마운트될 때와 화면 크기가 변경될 때마다 이벤트 리스너 등록
    handleResize(); // 초기 설정
    window.addEventListener('resize', handleResize);

    return () => {
      // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
      window.removeEventListener('resize', handleResize);
    };
  }, []);

    const [selectedSlide,setSelectedSlide] = useState(0);

    const handleSlideChange = (swiper) => {
        setSelectedSlide(swiper.activeIndex); // 슬라이드가 변경될 때마다 현재 슬라이드 인덱스 업데이트
      };

    return (
        <>
        <div className="w-screen h-screen flex flex-col items-center justify-start bg-[#F2F2F2] "> 
        <h2 className="font-bold text-3xl mt-10 mb-5">Project Gallery</h2>
        <div className="w-[100vw] h-[50vh]">
        <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        spaceBetween= {spaceBetween}
        coverflowEffect={{
          rotate: 100,
          stretch: 100,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="mySwiper"
        onSlideChange={handleSlideChange}
      >
        <SwiperSlide>
          <div className="flex justify-center items-center ">
          <div className="w-[40vh] h-[40vh] bg-[#87c4ed] rounded-xl">
                <div className="w-[40vh] h-[40vh] bg-[#444] bg-opacity-10 shadow-xl rounded-xl backdrop-blur-md flex flex-col justify-center items-center">
                    <div><img className='h-[10vh] w-[20vh]' src={mfbg} alt='프로젝트1로고'></img></div>
                    
                    <h3 className="text-3xl font-bold mt-12">Music-Forecast</h3>
                    <h3>Sound-Oasis</h3>
                </div>
            </div>

          </div>
        </SwiperSlide>

        <SwiperSlide>
        <div className="flex justify-center items-center">
          <div className="w-[40vh] h-[40vh] bg-white rounded-xl">
            <div className="w-[40vh] h-[40vh] bg-[#ffffff] bg-opacity-10 shadow-xl rounded-xl backdrop-blur-md flex flex-col justify-center items-center">
               <div><img className='h-[10vh] w-[10vh]' src={etabg} alt='프로젝트1로고'></img></div>
               <h3 className="text-2xl font-bold mt-12">ETA(Exercise-Tracker-App)</h3>
                        <h3>Beenzinoo</h3>
                    </div>
            </div>

          </div>
        </SwiperSlide>

        
        
        
      </Swiper>
        </div>

        <div>
            {selectedSlide===0 && (<div className="w-[50vw] h-[] flex flex-col">
                <div>
                  <div className='flex flex-row justify-between'>
                  <h3 className="text-2xl font-bold">Music-Forecast</h3>
                  <div>
                  <a className='w-[10vh] h-[5vh] mr-4 rounded-md shadow-md inline-flex justify-center items-center bg-white font-bold' href='https://github.com/codestates-seb/seb45_main_005' target='_blank'>Github</a>
                  <a className='w-[10vh] h-[5vh] rounded-md shadow-md inline-flex justify-center items-center bg-white font-bold' href='http://musicforecast.s3-website.ap-northeast-2.amazonaws.com/' target='_blank'>Deploy</a>

                  </div>
                  </div>
                <h3>Sound-Oasis</h3>
                </div>
                <div className='mt-8'>
                <span  className='w-[50vw] '>Music Forecast는 날씨와 어울리는 음악 플레이리스트를 추천해주는 사이트입니다.</span>
                </div>
                <div className='mt-2'>
                <span className='w-[50vw]'> 사용자의 상황,기분에 따라 다양한 음악을 추천하며, 자신만의 플레이리스트를 다른 사용자와 공유하는 기능또한 체험할 수 있습니다.</span>

                </div>
               
            </div>)}
            {selectedSlide===1 && (<div className="w-[50vw] h-[] flex flex-col ">
                <div>
                  <div className='flex flex-row justify-between'>
                  <h3 className="text-2xl font-bold">ETA (Exercise-Tracker-App)</h3>

                  <div>
                  <a className='w-[10vh] h-[5vh] mr-4 rounded-md shadow-md inline-flex justify-center items-center bg-white font-bold' href='https://github.com/YebinYun/exercise-tracker-app' target='_blank'>Github</a>
                  <a className='w-[10vh] h-[5vh] rounded-md shadow-md inline-flex justify-center items-center bg-white font-bold' href='https://dpftlel21.github.io/exercise-tracker-app/' target='_blank'>Deploy</a>

                  </div>
                  </div>
                
                <h3>Beenzinoo</h3>
                </div>

                <div className='mt-8'>
                <span className='w-[50vw]'>ETA(Exercise_Tracker_App)은 사용자의 운동 기록 및 계획을 작성할 수 있습니다.</span>

                </div>
                <div className='mt-4'>
                <span className='w-[50vw]'>사용자주변 헬스장 정보제공과 타이머 기능등 운동, 헬스케어에 필요한 다양한 기능들을 체험할 수 있습니다.</span>
                </div>
                
               
            </div>)}
        </div>
        
        </div>
        
        {/* <div className="flex justify-center w-full h-screen items-center">
            <div className="w-[1920px] h-[1080px] ">
            <iframe className="rounded-xl" src="http://musicforecast.s3-website.ap-northeast-2.amazonaws.com/" width="1920px" height="1080px"  style={{
            overflow: "hidden",
            transform: "scale(0.6)", 
        }}></iframe>
           
            </div>
        

        </div> */}
  </>
    )
}

export default Project;